export default "__VITE_ASSET__ab95c7cb__"